import { SessionAvailibilitySlot } from 'redux/actions/mentorship-program-connections';
import { MentoringProgramEnrollment } from './mentoring-program-enrollments';
import { SingleMentorRequestStatus } from './mentor-request';

export enum MentorshipProgramConnectionType {
  MANUAL = 'manual',
  AUTO_GENERATED = 'auto',
  REQUEST = 'request',
}

export type MentorshipProgramConnectionMember = {
  id: number;
  mentorshipProgramEnrollment: Pick<MentoringProgramEnrollment, 'id' | 'user' | 'role' >;
};

export type SessionAvailabilityByDay = {
  [day: string]: {
    slots: SessionAvailibilitySlot[];
    loading?: boolean;
  }
};

type SessionAvailabilitySlots = {
  [programId: number]: {
    [duration: number]: SessionAvailabilityByDay[];
  }
};

export type MentorshipProgramConnection = {
  id: number;
  mentorshipProgramId: number;
  formationType: MentorshipProgramConnectionType;
  mentorshipProgramConnectionMembers: MentorshipProgramConnectionMember[];
  createdAt?: Date;
  sessionAvailabilitySlots?: SessionAvailabilitySlots;
};

export type MentorshipProgramRequest = {
  id: number;
  message: string;
  createdAt: string;
  updatedAt: string;
  state: SingleMentorRequestStatus;
  menteeAnsweredDate: string | null;
  mentorAnsweredDate: string | null;
  mentorEnrollmentId: number;
  menteeEnrollmentId: number;
};
